<template>
  <div>
    <!-- Dialog :visible.sync="ativo" :closable="false" :modal="true" :contentStyle="{overflow: 'visible', width: '150px', height:'150px'}" -->
    <Dialog :visible.sync="ativo" :closable="false" :modal="true" position="center" :contentStyle="{overflow: 'visible'}">
      <template #header>
		    <h4>Aguarde...</h4>
	    </template>
      <div class="flex align-items-center justify-content-center mb-3">
        <ProgressSpinner strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
      </div>
    </Dialog>
  </div>
</template>

<script>
import ProgressSpinner from 'primevue/progressspinner';

export default {
  components: {ProgressSpinner},
  computed: {
      ativo() {
        return this.$store.state.dlgLoading;
      },
    },
}
</script>

<style>
</style>